import { render, staticRenderFns } from "./CoordinatorProfile.vue?vue&type=template&id=6fb5ebc2&scoped=true&"
import script from "./CoordinatorProfile.vue?vue&type=script&lang=js&"
export * from "./CoordinatorProfile.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorProfile.vue?vue&type=style&index=0&id=6fb5ebc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb5ebc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
